import { css } from '@emotion/core';
import { variables, applyFont, tokens, singleLineEllipsis, shadow } from '@domain-group/fe-brary';
var global = variables.global;
var colors = tokens.colors,
  typography = tokens.typography,
  shadows = tokens.shadows;
export var modal = /*#__PURE__*/css("position:fixed;z-index:", global.layerModal, ";user-select:none;right:0;bottom:0;left:0;display:flex;flex-direction:column;height:100%;top:0;width:100%;overflow:hidden;min-height:72px;background:", colors.neutral.surface.default, ";box-shadow:", shadow(shadows.elevation4), ";border-radius:3px;");

/* stylelint-disable property-no-vendor-prefix */
export var body = {
  name: "1nlj5ol",
  styles: "display:block;position:relative;width:100%;height:100%;min-height:200px;-webkit-transform:translate3d(0,0,0);"
};
export var scrollContainer = {
  name: "1g7xt6p",
  styles: "position:absolute;width:100%;top:0;bottom:0;overflow-y:auto;overflow-x:hidden;"
};
export var autocomplete = /*#__PURE__*/css("height:auto;background-color:", colors.neutral.surface.default, ";");
export var inputWrapper = /*#__PURE__*/css("display:flex;background:", colors.neutral.surface.default, ";border:1px solid ", colors.neutral.trim.default, ";overflow:hidden;border-radius:3px;align-items:flex-start;margin:16px;height:100%;");
export var itemList = {
  name: "xb4c7y",
  styles: "flex-grow:1;padding:8px;gap:4px;display:flex;flex-wrap:wrap;align-self:center;"
};
export var searchButton = {
  name: "1sq1bwi",
  styles: "margin:-1px;height:40px;width:40px;"
};
export var hiddenInput = {
  name: "1s0d4rv",
  styles: "position:absolute;opacity:0;height:0;font-size:16px;"
};
export var message = {
  name: "1uk1gs8",
  styles: "margin:0;"
};

// Mostly copied from `fe-co-typeahead`
export var comboxInput = _ref2 => {
  var isOpen = _ref2.isOpen;
  return isOpen ? /*#__PURE__*/css("min-width:30%;flex-grow:1;", applyFont(typography.body), " background:", colors.neutral.surface.default, ";color:", colors.neutral.heavy.default, ";border:0;padding:0;margin-left:2px;cursor:default;vertical-align:middle;outline:none;-webkit-appearance:none;font-family:inherit;box-shadow:none;overflow:hidden;display:flex;align-items:center;&:focus{outline:0;}&::placeholder{", singleLineEllipsis, " color:", colors.neutral.base.default, ";}") : hiddenInput;
};
export var optionSheetContainer = {
  name: "79elbk",
  styles: "position:relative;"
};
var _ref = {
  name: "1hyfx7x",
  styles: "display:none;"
};
export var optionSheet = _ref3 => {
  var isOpen = _ref3.isOpen;
  return isOpen ? /*#__PURE__*/css("width:100%;background:", colors.neutral.surface.default, ";z-index:", global.layerPopout, ";") : _ref;
};
export var footer = /*#__PURE__*/css("position:relative;height:60px;display:flex;justify-content:space-between;align-items:center;z-index:1000;background:", colors.neutral.surface.default, ";");
export var footerBody = {
  name: "1ia8ncw",
  styles: "display:flex;justify-content:flex-end;width:100%;height:40px;padding:0 16px;"
};
export var embeddedComponent = {
  name: "1c5ij41",
  styles: "margin:16px;"
};
export var suggestionExtension = {
  name: "s4xxni",
  styles: "margin:8px 16px;"
};
export var closeButton = {
  name: "g511ka",
  styles: "margin:-6px -6px;align-self:center;"
};